import { Component, OnInit } from "@angular/core";

import { Payment, PaymentStatus } from "../../models";
import { environment } from "../../../environments/environment";
import { fadeInAndOut } from "../../utils/animations-utils";
import { PaymentService } from "../../services/payment.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { PaymentRefundDialogComponent } from "../payment-refund-dialog/payment-refund-dialog.component";
import { AccountService } from "../../services/account.service";
import { ToastsManager } from "ng2-toastr";
import { TranslateService } from "@ngx-translate/core";

export enum PaymentFilter {
  PAYMENT_ID = "payment.paymentIntentId",
  AMOUNT = "payment.amount",
  REASON = "payment.cause",
  DATE = "payment.created",
  STATUS = "payment.status",
  CONTACT = "user.email",
}

@Component({
  selector: "app-payment-list",
  templateUrl: "./payment-list.component.html",
  animations: [fadeInAndOut()],
  styleUrls: ["./payment-list.component.css"],
})
export class PaymentListComponent implements OnInit {
  page = 1;
  itemsPerPage: number = environment.itemPerPage;
  total: number;
  listLoading: boolean;
  downloading: boolean;

  payments: Payment[] = [];

  sortingCriterias: Map<string, boolean> = new Map();
  filters: Map<string, string> = new Map();
  paymentFilterEnum = PaymentFilter;
  listFiltered: boolean;
  refundModal: NgbModalRef;

  constructor(
    private paymentService: PaymentService,
    private modalService: NgbModal,
    private accountService: AccountService,
    public toast: ToastsManager,
    public translate: TranslateService
  ) {}

  get isSuperAdmin() {
    return this.accountService.isSuperAdmin();
  }

  ngOnInit() {
    this.getPage(1);
  }

  getIsSucceed(payment: Payment): boolean {
    return payment.status === PaymentStatus.SUCCEEDED;
  }

  getIsRefund(payment: Payment): boolean {
    return (
      payment.status === PaymentStatus.REFUNDED ||
      payment.status === PaymentStatus.PARTIALLY_REFUNDED
    );
  }

  getPage(page: number) {
    this.page = page;
    this.listLoading = true;
    this.paymentService.getAllPayment();
    this.paymentService
      .getPaginatedFilteredSortedPayments(
        this.page,
        this.itemsPerPage,
        this.filters,
        this.sortingCriterias
      )
      .subscribe((data) => {
        this.payments = data.res;
        this.total = data.headers.get("x-total-count");
        this.listLoading = false;
      });
  }

  sortBy(criteria: string) {
    this.updateSortingCriterias(criteria);
    this.reloadList();
  }

  reloadList() {
    this.listFiltered = false;
    Object.values(this.filters).forEach((value) => {
      if (value) {
        this.listFiltered = true;
      }
    });
    this.getPage(1);
  }

  handleRefundClick(payment: Payment) {
    this.refundModal = this.modalService.open(PaymentRefundDialogComponent, {
      size: "sm",
      backdrop: "static",
    });
    this.refundModal.componentInstance.payment = payment;
  }

  updateSortingCriterias(criteria: string) {
    if (this.sortingCriterias.has(criteria)) {
      if (this.sortingCriterias.get(criteria)) {
        this.sortingCriterias.set(
          criteria,
          !this.sortingCriterias.get(criteria)
        );
      } else {
        this.sortingCriterias.delete(criteria);
      }
    } else {
      this.sortingCriterias.set(criteria, true);
    }
  }

  downloadXLSFile() {
    this.downloading = true;
    this.paymentService
      .downloadXLSFile(
        this.page,
        this.itemsPerPage,
        this.filters,
        this.sortingCriterias
      )
      .subscribe((isTruncated) => {
        if (isTruncated) {
          this.toast.warning(this.translate.instant("common.downloadOk"));
        } else {
          this.toast.success(
            this.translate.instant("common.downloadTruncated")
          );
        }
        this.downloading = false;
      });
  }

  changeItemCount(value) {
    this.itemsPerPage = value;
    this.reloadList();
    localStorage.setItem("itemsPerPage", value);
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/payment-list/payment-list.component.ts